import {InjectionToken} from '@angular/core';

export interface DetailFieldDefaults {
  truncateTitleText?: boolean;
  truncateTitleTextMaxLines?: number;
  truncateValue?: boolean;
  truncateValueMaxLines?: number;
  titleCSSClasses?: string;
  valueCSSClasses?: string;
  asRow?: boolean;
  fullWidth?: boolean;
}

export const MX_DETAIL_FIELD_DEFAULTS = new InjectionToken<DetailFieldDefaults>('MX_DETAIL_FIELD_DEFAULTS');
